export const faqItems = [
  {
    id: 'faq-1',
    question: '访问成人网站会不会让我的电脑中毒？',
    answer: '成人网站是恶意软件传播的高风险区域。很多成人网站会通过弹窗广告、虚假下载按钮等方式诱导用户安装恶意软件。但只要做好防护措施——安装可靠的杀毒软件、使用广告拦截器、不下载任何文件、保持浏览器更新——就可以大幅降低中毒风险。关键是要保持警惕，不要点击可疑的弹窗和链接。',
  },
  {
    id: 'faq-2',
    question: '我的浏览记录会不会被其他人看到？',
    answer: '默认浏览器会保存浏览历史，同设备的使用者或有权访问你设备的人可能看到这些记录。使用隐私模式可以防止本地记录保存，但这并不能阻止网络管理员或ISP看到你的访问。要全面保护隐私，建议组合使用VPN、隐私模式和定期清除浏览数据。',
  },
  {
    id: 'faq-3',
    question: 'VPN真的能完全保护我的隐私吗？',
    answer: 'VPN能提供重要的隐私保护，但并非万能。优质VPN可以加密你的流量并隐藏真实IP地址，防止ISP和网络管理员监控你的浏览内容。但VPN提供商本身可以看到你的流量，因此选择信誉良好、有明确"无日志政策"的VPN至关重要。此外，浏览器指纹等高级追踪技术可能绕过VPN的保护。',
  },
  {
    id: 'faq-4',
    question: '如何判断一个成人网站是否安全可靠？',
    answer: '评估成人网站安全性可以从以下几个方面入手：查看网站是否使用HTTPS加密连接（地址栏有锁形图标）；搜索该网站的用户评价和安全报告；检查网站是否有明确的隐私政策和联系方式；使用网站安全检测工具如VirusTotal扫描URL；注意是否有过多的弹窗广告和重定向。正规平台通常有更清晰的信息披露。',
  },
  {
    id: 'faq-5',
    question: '使用成人网站会违法吗？',
    answer: '这取决于你所在的国家和地区。在中国，传播淫秽物品是明确违法的，但个人访问境外成人网站目前处于法律灰色地带。建议你了解并遵守当地法律法规。无论如何，传播、分享、下载和存储相关成人内容可能构成违法行为，应当避免。',
  },
  {
    id: 'faq-6',
    question: '如何屏蔽手机上的成人内容弹窗广告？',
    answer: '首先，在手机设置中开启"阻止弹出式窗口"选项。其次，安装可靠的移动端广告拦截器。再者，如果弹窗出现在特定应用中，检查该应用的通知权限并关闭。对于通过浏览器出现的弹窗，可以安装具有广告拦截功能的移动浏览器。最后，定期清理浏览器缓存和Cookie也有帮助。',
  },
  {
    id: 'faq-7',
    question: '孩子可能接触到成人内容，我该怎么办？',
    answer: '首先不要过度反应。保持冷静并以此为契机进行一次网络安全教育对话。技术层面，可以设置路由器DNS过滤、设备家长控制、安装家庭安全软件。但更重要的是建立信任关系，让孩子知道他们可以随时和你讨论在网上看到的任何让他们不舒服的内容。定期检查设备的浏览记录和应用安装情况也是必要的。',
  },
];

export const safetyTips = [
  {
    id: 'tip-1',
    title: '使用独立邮箱',
    description: '注册成人平台时使用专用邮箱，避免与工作或个人邮箱关联。',
    icon: 'ri-mail-line',
  },
  {
    id: 'tip-2',
    title: '开启双重认证',
    description: '为所有重要账号启用双因素认证，增加账号安全层级。',
    icon: 'ri-lock-line',
  },
  {
    id: 'tip-3',
    title: '定期清除数据',
    description: '定期清理浏览器Cookie、缓存和浏览历史，减少数字足迹。',
    icon: 'ri-delete-back-line',
  },
  {
    id: 'tip-4',
    title: '安装广告拦截器',
    description: '使用可靠的广告拦截插件，防止恶意广告和追踪脚本。',
    icon: 'ri-advertisement-line',
  },
  {
    id: 'tip-5',
    title: '避免公共Wi-Fi',
    description: '不要在公共Wi-Fi网络下访问敏感内容，使用移动数据更安全。',
    icon: 'ri-wifi-off-line',
  },
  {
    id: 'tip-6',
    title: '更新软件系统',
    description: '保持操作系统和浏览器为最新版本，及时修复安全漏洞。',
    icon: 'ri-refresh-line',
  },
];